import { buildMissionInstructionPagesCore } from "../buildMissionInstructionPagesCore";
import { MISSION_THREE_BUBBLE_TEXT, getKeyLabel } from "./bubbleText";
import { MISSION_THREE_SCREENSHOT_LAYOUT_BY_PAGE } from "./screenshotLayout";
import {
 BUBBLE_DEFAULT_LAYOUT,
 DEFAULT_PAGE_UI,
 FELLOW_EMOTION_SOURCES,
 MISSION_THREE_BACKGROUND_SRC,
 MISSION_THREE_PAGE_COUNT,
 MISSION_THREE_PILOT_SRC,
 OVERLAY_BY_PAGE,
 OVERLAY_SIZE_PRESETS,
 PAGE_IDS,
 PAGE_UI_BY_PAGE,
 PILOT_LAYOUT_ADJUSTMENTS,
} from "./pageConfig";

export { MISSION_THREE_PAGE_COUNT };

const MISSION_THREE_CODED_PAGES = PAGE_IDS.map((id, index) => {
 const bubbleText = MISSION_THREE_BUBBLE_TEXT[index];
 const pageUi = { ...DEFAULT_PAGE_UI, ...(PAGE_UI_BY_PAGE[id] ?? {}) };
 const screenshotLayout = MISSION_THREE_SCREENSHOT_LAYOUT_BY_PAGE[id] ?? {};
 const defaultScreenshotTitle = `Screen ${index + 1}`;
 return {
  id,
  audioSrc: bubbleText.audioSrc,
  overlay: OVERLAY_BY_PAGE[id],
  backgroundSrc: MISSION_THREE_BACKGROUND_SRC,
  fellowSrc: resolveFellowSource(bubbleText),
  pilotSrc: MISSION_THREE_PILOT_SRC,
  showPilot: pageUi.showPilot,
  bubbleText,
  screenshot: {
   ...screenshotLayout,
   title: screenshotLayout.title ?? defaultScreenshotTitle,
   details: screenshotLayout.details ?? [],
  },
 };
});

function resolveFellowSource(bubbleObj) {
 const emotionKey = String(bubbleObj?.fellowEmotion ?? "hq-speaking").toLowerCase();
 return FELLOW_EMOTION_SOURCES[emotionKey] ?? FELLOW_EMOTION_SOURCES["hq-speaking"];
}

export function buildMissionThreeInstructionPages(jsPsych, instructionAudio) {
 return buildMissionInstructionPagesCore({
  jsPsych,
  instructionAudio,
  pages: MISSION_THREE_CODED_PAGES,
  overlaySizePresets: OVERLAY_SIZE_PRESETS,
  bubbleDefaultLayout: BUBBLE_DEFAULT_LAYOUT,
  pilotLayoutAdjustments: PILOT_LAYOUT_ADJUSTMENTS,
  getKeyLabel,
 });
}
